import { Stack } from '@mui/material';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useState } from 'react';

import {
  Loading,
  NewFilterSummary,
  NoSearchResults,
  SummaryCardNew,
} from '@hapvida/hapvida-core-components';

import { useFilterParams } from '@hooks';

import type { CoparticipationPreviewMobileCardProps } from './types';
import { CoparticipationCardMobile } from '../CoparticipationPreviewReportCard/components/CoparticipationPreviewReportTable/components';
import { CopartSearch } from '../CopartSearch';

export function CoparticipationPreviewReportMobileCard({
  hasNextPage,
  fetchNextPage,
  isLoading,
  data,
}: Readonly<CoparticipationPreviewMobileCardProps>) {
  const { hasFilters } = useFilterParams();
  const [openRows, setOpenRows] = useState<Record<string, boolean>>({});

  const toggleRow = (id: string) => {
    setOpenRows(prev => ({ ...prev, [id]: !prev[id] }));
  };

  const copartPreviewData =
    data?.pages
      ?.map(
        coparticipationPreview =>
          coparticipationPreview?.coparticipationPreviewReports,
      )
      .flat() ?? [];

  const totalListLength = data?.pages[0]?.total ?? 0;

  const isEmpty = totalListLength === 0;

  const isEmptyResult = isEmpty && hasFilters;

  const filterSummaryLabel = `${totalListLength} ${
    totalListLength === 1 ? 'beneficiário' : 'beneficiários'
  }`;

  return (
    <SummaryCardNew.Container>
      <SummaryCardNew.Header title="Prévia de coparticipação" />
      <CopartSearch isLoading={isLoading} />
      <NewFilterSummary totalLabel={filterSummaryLabel} />

      {isEmptyResult && <NoSearchResults padding={5} />}
      {!isEmpty && (
        <Stack gap={2}>
          <InfiniteScroll
            dataLength={copartPreviewData.length}
            hasMore={Boolean(hasNextPage)}
            next={fetchNextPage}
            loader={<Loading animationProps={{ height: 20, width: 20 }} />}
            height={'800px'}
          >
            <Stack gap={1.5}>
              {copartPreviewData.map(row => (
                <CoparticipationCardMobile
                  key={row.id}
                  row={row}
                  open={Boolean(openRows[row.id])}
                  onToggle={toggleRow}
                />
              ))}
            </Stack>
          </InfiniteScroll>
        </Stack>
      )}
    </SummaryCardNew.Container>
  );
}
